<template>
  <el-config-provider :locale="locale">
    <!-- 这里是内容 -->
    <router-view v-slot="{ Component, route }">
      <!-- <keep-alive> -->
      <component :is="Component" :key="route.fullPath" />
      <!-- </keep-alive> -->
      <!-- <component :is="Component" v-if="!$route.meta.keepAlive" :key="route.fullPath" /> -->
    </router-view>
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
// 引入中文包
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  setup() {
    const lang = () => {
      // eslint-disable-line no-unused-vars(如果运行时报错，就加上前面这行注释)
      location.reload()
    }
    let locale = zhCn
    return {
      locale
    }
  }
}
</script>

<style lang="scss">
@import './assets/css/cssnormal';
@import './assets/css/elstyle';
</style>
